import { Extension } from '@tiptap/core';
import '@tiptap/extension-text-style';

export type ColorOptions = {
  types: string[];
};

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    color: {
      unsetColor: () => ReturnType;
      setColor: (backgroundColor: string | null) => ReturnType;
    };
  }
}

export const Color = Extension.create<ColorOptions>({
  name: 'color',

  addOptions() {
    return {
      types: ['textStyle', 'link'],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (element) => element.style.color.replace(/['"]+/g, ''),
            renderHTML: (attributes: Record<string, string>) => {
              if (!attributes['color']) {
                return {};
              }
              return {
                style: `color: ${attributes['color']}`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      unsetColor:
        () =>
        ({ chain }) => {
          return chain().setMark('textStyle', { color: null }).removeAllEmptySpan().run();
        },
      setColor:
        (color) =>
        ({ chain, tr }) => {
          return chain().setMark('textStyle', { color }).run();
        },
    };
  },
});
